import type { TFunction as I18nextTFunction } from 'i18next';
import type { LegacyStringTFunction } from './i18next-types';

/** react-i18next の Trans 等が要求する branded t へ渡すためのキャスト */
export const toI18nextT = (t: LegacyStringTFunction): I18nextTFunction => t as unknown as I18nextTFunction;